import { render } from 'react-dom';
/* eslint-disable no-unused-vars */
import React from 'react';
import { BrazeContentCards } from './components/brazecontentcards/brazecontentcards';
/* eslint-enable no-unused-vars */
import AccountService from '../_shared/account-service';

export default class BrazeContentCardsWrapper {
  /**
   * @param {string} containerSelector
   */
  constructor(containerSelector) {
    this.$container = document.getElementById(containerSelector);

    this.init();
  }

  async init() {
    this.initialized = true;

    if (!this.$container) {
      this.initialized = false;
      return;
    }

    this.userData = await AccountService.getUserData();
    this.renderReact();
  }

  renderReact() {
    render(
      <BrazeContentCards keyValuePairs={[{ key: 'Cityzens', value: 'Top' }]} userId={this.userData?.id} />,
      this.$container,
    );
  }
}
